export default function YearTab({ year }) {
    return (
        <div className="yearcontainer"><p className="year"><span>{year}</span></p></div>
    )
}